// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_arNnb {
  width : 100%;
}

.lines_FFTkf {
  width: 100%;
  overflow-x: scroll;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/lineLiveStatus/LiveLineStatusComponent.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".header {\n  width : 100%;\n}\n\n.lines {\n  width: 100%;\n  overflow-x: scroll;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_arNnb`,
	"lines": `lines_FFTkf`
};
export default ___CSS_LOADER_EXPORT___;
